import { stripRichMarkers } from "@/lib/richFormat";

// Lot 779 — publication « telle qu'au fil » construite depuis l'état du composeur (aperçu avant publication).
const src = (a) => a.localUrl || a.url || "";

// Même forme que la publication renvoyée par le serveur (sans compteurs) ; médias = fichiers locaux (blob:) ou déjà envoyés.
export const buildPreviewPost = (c, user) => {
  const church = c.churchId
    ? { id: c.churchId, name: c.churchName }
    : (c.needsPublishAs && c.publishAs && c.publishAs !== "me" ? (c.myChurches || []).find((x) => x.id === c.publishAs) : null);
  const author = church
    ? { id: church.id, name: church.name, avatar_url: church.logo_url || null, is_church: true, church_id: church.id }
    : { id: user.id, name: user.name, avatar_url: user.avatar_url, gender: user.gender, role: user.role, is_verified: user.is_verified };
  const visuals = c.visualAtts || [];
  const vid = c.videoAtt || null;
  const bgOnly = !c.hasMedia && !!c.bg;
  const post = {
    id: "preview", is_preview: true, is_owner: true, author, author_id: author.id,
    content: bgOnly ? stripRichMarkers(c.content || "") : (c.content || ""),
    created_at: new Date().toISOString(),
    images: (c.imageAtts || []).map(src),
    image_dims: Object.fromEntries((c.imageAtts || []).filter((a) => a.width > 0 && a.height > 0).map((a) => [src(a), [a.width, a.height]])),
    bg: bgOnly ? c.bg : null,
    text_scale: bgOnly && c.textScale !== 1 ? c.textScale : null,
    mentions: c.usedMentions || [],
    group_id: c.groupId || null,
    as_church_id: church ? church.id : null,
    visibility: !church && !c.groupId ? c.audience : null,
    embed: c.linkPreview && !c.hasMedia ? c.linkPreview : null,
    embed_dismissed: !(c.linkPreview && !c.hasMedia),
    reactions: {}, reaction_total: 0, comment_count: 0,
  };
  if (c.testimonyOn) { post.post_type = "testimony"; post.testimony_category = c.testimonyCat; }
  if (c.audioAtt) { post.audio_url = src(c.audioAtt); post.audio_duration = c.audioAtt.duration || null; }
  if (vid) {
    post.video_url = src(vid); post.poster_url = vid.localPoster || vid.posterUrl || null;
    post.video_duration = vid.duration || null; post.is_reel = !!c.effectiveIsReel; post.video_fx = vid.fx || null;
  }
  if (visuals.length > 1) {
    post.album = visuals.map((a) => ({ type: a.kind, url: src(a), ...(a.width > 0 && a.height > 0 ? { width: a.width, height: a.height } : {}), ...(a.localPoster || a.posterUrl ? { poster_url: a.localPoster || a.posterUrl } : {}), ...(a.duration ? { duration: a.duration } : {}), ...(a.caption?.trim() ? { caption: a.caption.trim() } : {}) }));
    if (c.canBeforeAfter && c.layout === "before_after") post.album_layout = "before_after";
  }
  return post;
};
